// extracted by mini-css-extract-plugin
module.exports = {"marketLink":"market_marketLink__uL0OG","active":"market_active___vbln","marketText":"market_marketText__WggDC"};